const entityName = 'quotations';

const quotationModule = {
  state: {},
  mutations: {},
  actions: {
    fetchAll: (context) => {
      const url = entityName;
      return context.dispatch('getAllEntity', {url, entityName})
    },
    postQuotation: (context, quotation) => {
      const payload = {
        url: entityName,
        entityName: entityName,
        entity: quotation
      };
      return context.dispatch('postEntity', payload)
    },
    updateQuotation: (context, quotation) => {
      const payload = {
        url: entityName + '/' + quotation._id,
        entityName: entityName,
        entity: quotation
      };
      return context.dispatch('putEntity', payload)
    },
    removeQuotation: (context, quotation) => {
      const payload = {
        url: entityName + '/' + quotation._id,
        entityName: entityName,
        entity: quotation
      };
      return context.dispatch('deleteEntity', payload)
    },
  },
  getters: {}
};

export default quotationModule;
